import axios from "axios";

export const getReadingTypes = async () => {
    const response = await axios.get(`api/sensorDataReadingTypes`);
    const readingTypes = response.data;
    return readingTypes;
}


